// extracted by mini-css-extract-plugin
export default {"video_container":"audio_video_container__R+R7s","vect":"audio_vect__cjgnV","back_ground_img":"audio_back_ground_img__VzWy7"};